import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import DropdownBar from '@ifca-root/react-component/src/components/SpecialBar/DropdownBar'
import { SearchBar } from '@ifca-root/react-component/src/components/SpecialBar/SearchBar'
import { useFilterDialog } from '@ifca-root/react-component/src/components/SpecialBar/SearchFilter/SearchFilterV2'
import { Tune } from '@material-ui/icons'
import {
  useGetCompanyNameQuery,
  useGetLeaseContractLazyQuery,
  useGetUsersByAccountAndSoftwareQuery,
} from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { LeaseContractEntryList } from '../LeaseContract/LeaseContractListing/LeaseContractEntryList'

export const MFRS16JournalMain = (props: any) => {
  const { transactionType, transactionTypePrefix }: any = props
  let history = useHistory()
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  /* -------------------------------------------- */
  /*                    SEARCH                    */
  /* -------------------------------------------- */
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const {
    filteredList,
    handleSearch,
    setOriginalListing,
    originalList,
  } = useFuseSearch()

  const { openFilterDialog, handleFilterDate, filterDialog } = useFilterDialog({
    dateRange: {
      title: 'Doc Date',
      key: 'DocDate',
    },
  })

  /* -------------------------------------------- */
  /*                     ENUM                     */
  /* -------------------------------------------- */
  const yearOptions = [
    { name: '2024', ID: '2024' },
    { name: '2023', ID: '2023' },
    { name: '2022', ID: '2022' },
  ]

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */
  const [listStatus, setListStatus] = useState<string>(
    getSearch?.option ?? '2024'
  )

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */
  const {
    loading: CompanyLoading,
    data: { getCompany } = { getCompany: [] },
  } = useGetCompanyNameQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onCompleted: ({ getCompany }) => {
      if (getCompany?.length > 0)
        loadLeaseContract({
          variables: {
            statusArr: [listStatus],
            CompanyID: CompanyID,
            skip: 0,
            take: 30,
            searchValue:
              getSearch?.name === '' || !getSearch?.name
                ? undefined
                : getSearch?.name,
          },
        })
    },
  })
  const [
    loadLeaseContract,
    {
      loading: LeaseContractLoading,
      data: { getLeaseContract } = { getLeaseContract: [] },
    },
  ] = useGetLeaseContractLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ getLeaseContract }) => {
      if (getLeaseContract?.length >= 30) {
        setOriginalListing([...filteredList, ...getLeaseContract])
      } else {
        setOriginalListing([...getLeaseContract])
      }
    },
  })

  /* -------------------------------------------- */
  /*                   FUNCTION                   */
  /* -------------------------------------------- */
  useEffect(() => {
    setOriginalListing([])
    loadLeaseContract({
      variables: {
        // statusArr: [listStatus],
        CompanyID: CompanyID,
        skip: 0,
        take: 30,
        searchValue:
          getSearch?.name === '' || !getSearch?.name
            ? undefined
            : getSearch?.name,
      },
    })
  }, [listStatus])

  const [timer, setTimer] = useState(null)

  const changeDelay = change => {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }
    setTimer(
      setTimeout(() => {
        setOriginalListing([])
        loadLeaseContract({
          variables: {
            statusArr: [listStatus],
            CompanyID: CompanyID,
            skip: 0,
            take: 30,
            searchValue:
              getSearch?.name === '' || !getSearch?.name
                ? undefined
                : getSearch?.name,
          },
        })
      }, 1000)
    )
  }

  return (
    <>
      {CompanyLoading && <Loading />}
      {LeaseContractLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/mfrs16/${CompanyID}`)
          localStorage.removeItem(`searchFilter`)
        }}
        smTitle={'MFRS 16'}
        title={user?.companyName}
        routeSegments={[
          { name: 'MFRS 16' },
          { name: 'Generate MFRS 16 Journal', current: true },
        ]}
      />
      <div className="search-filter with-dropdown-filter">
        <SearchBar
          borderRadius="4px"
          onChangeAction={e => {
            handleSearch(e?.target?.value, [''])
            localStorage.setItem(
              'searchFilter',
              JSON.stringify({
                option: listStatus ?? 'ACTIVE',
                name: e?.target?.value,
              })
            )
          }}
          isDefaultValue={!!getSearch}
          defaultValue={getSearch?.name ? getSearch?.name : ''}
          onCloseAction={() => {
            handleSearch('', [])
            setOriginalListing([])
            localStorage.removeItem('searchFilter')
            loadLeaseContract({
              variables: {
                statusArr: [listStatus],
                CompanyID: CompanyID,
                skip: 0,
                take: 30,
              },
            })
          }}
          option={{
            icon: <Tune />,
            onClick: openFilterDialog,
          }}
        />
        {filterDialog}
        <DropdownBar
          options={yearOptions}
          setOptionID={setListStatus}
          borderRadius="4px"
          defaultOption={yearOptions
            ?.map(opt => opt?.ID)
            .indexOf(listStatus ?? '2024')}
          searchFilter={getSearch}
        />
      </div>
      <LeaseContractEntryList
        loading={LeaseContractLoading}
        filteredList={filteredList}
        setOriginalListing={setOriginalListing}
        listStatus={listStatus}
        loadData={loadLeaseContract}
        CompanyID={CompanyID}
        getSearch={getSearch}
        transactionTypePrefix={transactionTypePrefix}
      />
    </>
  )
}
